import IconTextDescription from './IconTextDescription';
import { IconTextDescriptionProps, IconTextDescriptionValueProps, IconTextDescriptionCombinedProps } from './types';

export type { IconTextDescriptionProps, IconTextDescriptionValueProps, IconTextDescriptionCombinedProps };
export default IconTextDescription;
